// extracted by mini-css-extract-plugin
module.exports = {"results":"results-33xJJ","mobilePriceGraph_dates":"mobilePriceGraph_dates-1eX3m"};